import { useSelector } from 'react-redux';
import { CreateNumberTrackerMutationVariables, CreateNumberTrackerInput } from '../../../graphql';
import { voucherSettingType } from '../types';
import { CreateNumberTrackerMutationFN } from './createFinancialyear.api';

export const createNumberTrackerSettings = async (input: voucherSettingType): Promise<void> => {
  const financialyearid: number = Number(input.financialyearid);
  const companyid: number = Number(input.companyid);
  const regType: number = Number(input.regType);
  const commonFields: Omit<CreateNumberTrackerInput, 'entrytypecd' | 'serialnumber' | 'serialflag' | 'prefix'> = {
    serialisactive: 1,
    startinvoicenumber: 1,
    serialisused: 0,
    nextinvoicenumber: 1,
    suffix: '',
    financialyearid,
    companyid,
  };

  const inputArray: CreateNumberTrackerInput[] = [
    {
      ...commonFields,
      entrytypecd: 'SalesInvoice',
      serialnumber: 'SINV',
      serialflag: 2,
      prefix: 'SINV',
      taxability: 1,
      restrictedflag: 1,
    },
    {
      ...commonFields,
      entrytypecd: 'SalesInvoice',
      serialnumber: 'BOS',
      serialflag: 1,
      prefix: 'BOS',
      taxability: 3,
      restrictedflag: 1,
    },
    {
      ...commonFields,
      entrytypecd: 'PosInvoice',
      serialnumber: 'POS',
      serialflag: 2,
      prefix: 'POS',
      taxability: 1,
      restrictedflag: 1,
    },
    {
      ...commonFields,
      entrytypecd: 'PosInvoice',
      serialnumber: 'PBOS',
      serialflag: 1,
      prefix: 'PBOS',
      taxability: 3,
      restrictedflag: 1,
    },
    {
      ...commonFields,
      entrytypecd: 'PurchaseInvoice',
      serialnumber: 'PINV',
      serialflag: 2,
      prefix: 'PINV',
      restrictedflag: 1,
    },
    {
      ...commonFields,
      entrytypecd: 'Payment',
      serialnumber: 'PMT',
      serialflag: 2,
      prefix: 'PMT',
      restrictedflag: 1,
    },
    {
      ...commonFields,
      entrytypecd: 'Receipt',
      serialnumber: 'RPT',
      serialflag: 2,
      prefix: 'RPT',
      restrictedflag: 1,
    },
    {
      ...commonFields,
      entrytypecd: 'Journal',
      serialnumber: 'JV',
      serialflag: 2,
      prefix: 'JV',
      restrictedflag: 1,
    },
    {
      ...commonFields,
      entrytypecd: 'CreditInvoice',
      serialnumber: 'CDN',
      serialflag: 2,
      prefix: 'CDN',
      restrictedflag: 1,
    },
    {
      ...commonFields,
      entrytypecd: 'DebitInvoice',
      serialnumber: 'DBN',
      serialflag: 2,
      prefix: 'DBN',
      restrictedflag: 1,
    },
  ];

  const finalArray =
    regType === 1 || regType === 3 ? inputArray.filter((o) => o.serialnumber !== 'SINV' && o.serialnumber !== 'POS') : inputArray;
  console.log(regType, finalArray, 'finalArray');

  for (const inputItem of finalArray) {
    const payload: CreateNumberTrackerMutationVariables = {
      createNumberTrackerInput: [inputItem],
    };

    try {
      await CreateNumberTrackerMutationFN(payload);
    } catch (error: unknown) {
      throw error;
    }
  }
};
